// STB (Surat Terima Barang) as native ESC/P for the Epson LX-310.
// Content mirrors the HTML version in ../printSTBUtils.js; the page layout
// (boxed table, page numbers, footer) is rendered by halfFormEscp.js.

import {
  buildHalfFormDoc,
  STANDARD_COLUMNS,
  STANDARD_TOTALS,
} from "./halfFormEscp";

const fmtDate = (data) => {
  const raw =
    data.tanggal || data.transaction_date || data.created_at || new Date();
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
};

const CONFIG = {
  title: "SURAT TERIMA BARANG (STB)",
  infoLines: (data) => [
    ["TANGGAL", fmtDate(data), "No. SJ", data.no_sj || data.sj_number || "-"],
    [
      "NO STB",
      data.document_number || data.stb_number || data.id,
      "GUDANG TUJUAN",
      data.warehouse_name || "-",
    ],
  ],
  columns: STANDARD_COLUMNS,
  groupHeader: { label: "JUMLAH", span: 2 },
  totalSpan: 5,
  totals: STANDARD_TOTALS,
  notes: (data) => data.notes || data.remarks || "-",
  signatureLabel: "Yang menerima,",
  signatureName: (data) =>
    data.receiver_name ||
    data.user_username ||
    data.user_email ||
    "(_______________)",
  maxItemsPerPage: 7,
};

/**
 * Build the full ESC/P document string for an STB.
 * @param {object} data the same data object passed to printSTB()
 * @param {number} itemsPerPage rows per page (matches the HTML paginator)
 * @returns {string} ESC/P bytes ready for qzClient.printRaw()
 */
export const buildSTBEscp = (data, itemsPerPage = 6) =>
  buildHalfFormDoc(CONFIG, data, itemsPerPage);

export default buildSTBEscp;
